import FullScreenCard from '../../shared/FullScreenCard';
import Table from '../../shared/Table';
import { fetchBody } from '../../../utils/fetch';
import { useContext, useEffect, useState } from 'react';
import { transformDate } from '../../../utils/date';
import GeneralContext from '../../../context/GeneralContext';

function AdminHistoryPoints() {

    const { changeCurrentMenu, userAdminHistoryId, userAdminHistoryName } = useContext(GeneralContext);

    const [headers, setHeaders] = useState([
        {id: 'header0', text: 'Alerta'}
    ]);

    const [historyList, setHistoryList] = useState([
    {id: '1a', fields: [
            {id: '0', text: 'Error conectándose al servidor'}
        ]
    }
    ]);

    const prepareHistoryList = (list) => {
        setHeaders([
            {id: 'header0', text: 'Cambio'},
            {id: 'header1', text: 'Fecha'},
            {id: 'header2', text: 'Repsonsable'},
            {id: 'header3', text: 'Tipo'},
            {id: 'header4', text: 'Razón'}
        ]);
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            let changeType;
            let changeAmount;
            if (list[i].type === 'approve') {
                changeType = 'Aprobación de solicitud';
                changeAmount = list[i].change;
            };
            if (list[i].type === 'adjust') {
                changeType = 'Ajuste de puntos';
                list[i].change > 0 ? changeAmount = '+' + list[i].change : changeAmount = list[i].change;
            };
            if (list[i].type === 'reset') {
                changeType = 'Restablecimiento general';
                changeAmount = list[i].change;
            };
            const item = {
            id: i,
            fields: [
                {id: '0', text: changeAmount},
                {id: '1', text: transformDate(list[i].date)},
                {id: '2', text: list[i].change_author},
                {id: '3', text: changeType},
                {id: '4', text: list[i].reason}
            ]
            }
            newList.push(item);
        }
        setHistoryList(newList);
    }

    useEffect(() => {
        const getUsersList = async () => {
            const fetchData = { id: userAdminHistoryId }
            const response = await fetchBody('points/history/', 'POST', fetchData);
            if (response.success) {
                prepareHistoryList(response.list);
            }
        }
        getUsersList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'users-points'}>
      <h2>Historial de Cambios de Puntos de {userAdminHistoryName}</h2>
      <Table
        headers={headers}
        data={historyList}
        type='display'
        />
    </FullScreenCard>
  )
}

export default AdminHistoryPoints